const MANIFESTS = {
  client: '/manifest-client.json',
  admin: '/manifest-admin.json'
};

const TITLES = {
  client: 'SAHALGUUR Services',
  admin: 'SAHALGUUR Admin'
};

export const applyPwaManifest = (variant = 'client') => {
  if (typeof document === 'undefined') return;

  const href = MANIFESTS[variant] || MANIFESTS.client;
  let link = document.querySelector('link[rel="manifest"]');
  if (!link) {
    link = document.createElement('link');
    link.rel = 'manifest';
    document.head.appendChild(link);
  }
  if (link.getAttribute('href') !== href) {
    link.setAttribute('href', href);
  }

  document.title = TITLES[variant] || TITLES.client;

  let appleTitle = document.querySelector('meta[name="apple-mobile-web-app-title"]');
  if (!appleTitle) {
    appleTitle = document.createElement('meta');
    appleTitle.name = 'apple-mobile-web-app-title';
    document.head.appendChild(appleTitle);
  }
  appleTitle.content = variant === 'admin' ? 'SG Admin' : 'SAHALGUUR';
};

export const isStandaloneDisplay = () => {
  if (typeof window === 'undefined') return false;
  return (
    window.matchMedia('(display-mode: standalone)').matches
    || window.navigator.standalone === true
  );
};
